module.exports = __webpack_public_path__ + "img/gslogo_128x128.d79fd934.png";